import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import React, { useState, useEffect } from 'react';
import DashboardService from '../../../services/dashboard-service.js';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MerchantsService from "../../../services/merchants-service.js";
import { agentsList } from "./../../../actions/agent-actions.js";
import { useSelector, useDispatch } from 'react-redux';
import { MESSAGES } from '../../constants/constants.js';


const Roles = () => { 
  const dispatch = useDispatch();
  const [role,setUserRole] = useState('');
  const [status,setStatus] = useState('');

  const [loading, setLoading] = useState(false);
  const [transaction , setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const [filterData, setFilterData] = useState({
    end_date: '',
    start_date: '',
    merchantID: '',
    agentID: '',
    paymentType: ''
  });
  const columns = [
    {
      name: 'Order ID',
      selector: row => row.order_code,
      sortable: true,
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => row.start_date,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      {
        row.status == 'P' && (
          <span className="badge badge-pill badge-soft-pending font-size-11">Pending</span>
        )
      }
      {
        row.status == 'AA' && (
          <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
        )
      }
       {
        row.status == 'AR' && (
          <span className="badge badge-pill badge-soft-danger font-size-11">Rejected</span>
        )
      }
       
      {
        row.status == 'R' && (
          <span className="badge badge-pill badge-soft-danger font-size-11">Raised</span>
        )
      }
        {
          row.status == 'RF' && (
          <span className="badge badge-pill badge-soft-warning font-size-11">Refund</span>
        )
      }
        {
          row.status == 'C' && (
          <span className="badge badge-pill badge-soft-success font-size-11">Paid</span>
        )
      }
      </>,
      
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => '₹' + row.amount,
      sortable: true,
    },
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
                            row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method}
      
      </>
      
      ,
      sortable: true,
    },
    {
        name: "Actions",
        button: true,
        cell: row =>
         <>
               <a className="fview tooltip" style={{'cursor':'pointer'}}  >
           <i className="fa fa-eye" style={{ color: 'black' }}/>
            <span className="tooltiptext">View</span>
          </a>
              <a className="flock tooltip"style={{'cursor':'pointer'}}>
              <i className={'fa fa-unlock'}  style={{ color: 'black' }}/>
              <span className="tooltiptext">
                <>
                 Lock
                </>
      
              </span>
            </a>
            <a className={`fedit tooltip`} style={{'cursor':'pointer'}}  onClick={() => editMerchant(row)}>
              <i  className={`fa fa-edit`}   style={{ color: 'black' }}/>
              <span className="tooltiptext">Edit</span>
            </a>
            <a className="ftrash tooltip" style={{'paddingRight':'25px', 'cursor':'pointer'}}>
              <i className="fa fa-trash"   style={{ color: 'black' }}/>
              <span className="tooltiptext">Delete</span>
            </a>
         
            </>
     
      }
  ];
const viewTransaction = (id) => {
  navigate(`/transaction/${id}`)
}

const confirm = (id,orderCode) => {
  navigate(`/confirm-transaction/${id}/${orderCode}}`)
}

const raised = (id,orderCode) => {
  navigate(`/raised-transaction/${id}/${orderCode}`)
 
}

  const listTransactions = (fiterReset = false, pageNumber, rowsPage, status) => {
    setStatus(status)
    let userRole = '';
    let transaction =  DashboardService.getTransactionsList(fiterReset ? {} : filterData, pageNumber, rowsPage, status)
    if(userData.user.data) {
      userRole = userData.user.data.role
    }
    if(userRole == 'ADMIN') {
    //  transaction =  DashboardService.getTransactionsListAdmin()
    }
    setLoading(true);
   
    transaction.then(response => {
      console.log(response)
      const records = response.data.data.list
      
      setTotalRows(response.data.data.total_records)



      setTransactionData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
  const getAgents = () => {
    setLoading(true);
    dispatch(agentsList())
    .then((response) => {
      const agents = response.data.Active
      const arr = [];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].full_name,
          value: agents[i].user_id,
        })
      }
      console.log(arr);
      setAgents(arr);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }
  
  const getMerchantsList = (e) => {
    setLoading(true);
    MerchantsService.getMerchants()
      .then(response => {
        const merchts = response.data.data;
        const arr = [];
        for(var i=0; i<merchts.length; i++) {
          if(merchts[i].merchant_detail.status_id == 'A') {
            arr.push({
              name: merchts[i].merchant_detail.merchant_name,
              value: merchts[i].merchant_detail.merchant_id,
            })
          }
          
        }
        setMerchants(arr);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }


  useEffect(() => {
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       setUserRole(userRole)
    }
    if(userRole !='ADMIN') {
      listTransactions(false,0,10,"P");
    } else {
      getAgents();
      getMerchantsList();
    }
   
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'P':
        return 'Pending';
      case 'R':
        return 'Raised';
      case 'RF':
        return 'Refund';
      case 'C':
        return 'Paid';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = transaction && transaction.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });


      const handleChange = (e) => {
        const { name, value } = e.target;
        if(name == 'merchantID') {
          setFilterData((prevData) => ({ ...prevData, ['agentID']: '' }));
        }
        if(name == 'agentID') {
          setFilterData((prevData) => ({ ...prevData, ['merchantID']: '' }));
        }
      
        setFilterData((prevData) => ({ ...prevData, [name]: value }));
      
      };
      const applyFilter = () => {
       
        listTransactions(false, pageNo, rowsPerPage,status);
      }
      
      const cancelFilter = () => {
        setFilterData({
          end_date: '',
          start_date: '',
         
          paymentType: ''
      })
      setPageNo(0)

      listTransactions(true,0,rowsPerPage,status);
      }
      const handleRowsPerPageChange = (e) => {
        let rowsPage = Number(e.target.value)
        setRowsPerPage(rowsPage);
        setDataTableKey(prevKey => prevKey + 1);
        listTransactions(false,pageNo, rowsPage,status)
      };
   
      const handlePageChange = page => {
        let pageNumber = page - 1;
        setPageNo(pageNumber)
        listTransactions(false, pageNumber, rowsPerPage,status);
      };
      
    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Transaction History</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" >Transactions</button>
              {/* <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"  onClick={() => resetSearch('Complete')} tabIndex={-1}>Complete Transaction</button> */}
            </div>
          </nav>
          <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                      
                  </div>

                    <div className="dataTables_length" id="examplemgm_length">
                                    <label>Show &nbsp;</label>
                      <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                       
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{textAlign: 'right'}}>
                      <div>
        <a style={{marginRight: '10px'}} className="dropdown-toggle noapply show" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true">
          <button style={{backgroundColor: 'white !important', color: 'black !important', border: '1px solid #e5e5e5', padding: '3px 10px', borderRadius: '5px', marginBottom: '10px', fontSize: '13px'}} type="button" name="btn_login_details" className="btn sebtn">
            <i style={{color: 'black'}} className="fa fa-filter" aria-hidden="true" /> Filter 
          </button>
        </a>
        <div className="row dropdown-menu dropdown-menu-endd mbv" id="nvb" aria-labelledby="navbarDropdown" style={{display: 'none', position: 'absolute', inset: '0px auto auto 0px', margin: '0px', transform: 'translate3d(43.5556px, 150.222px, 0px)'}} data-popper-placement="bottom-start">
          <div className="col-md-12">
            <h5 className="daterange">Filter</h5>
            <h5 className="sdfgt">Date range</h5>
            <div className="col-md-6" style={{paddingRight: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="start_date">From :</label>
              <br />
              <input type="date" value={filterData.start_date} onChange={handleChange} className="form-control" id="start_date" name="start_date" required />
            </div>
            <div className="col-md-6" style={{paddingLeft: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="end_date">To :</label>
              <br />
              <input type="date"  value={filterData.end_date} onChange={handleChange} className="form-control" id="end_date" name="end_date" required />
            </div>

            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px !important'}}>
                <label className htmlFor="Industry">Payment Type</label>
                <select onChange={handleChange}  value={filterData.paymentType} name="paymentType" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value>Select Payment Type</option>
                  <option value="Payin">Payin</option>
                  <option value="Payout">Payout</option>
                </select>
              </div>
            </div>
            {(role =='ADMIN' && 
            <>
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px !important'}}>
                <label className htmlFor="Industry">Agent</label>
                <select name="agentID" value={filterData.agentID} className="drp" onChange={handleChange} id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value="">Select Agent</option>
                  {agents.map(agent => (
          <option key={agent.value} value={agent.value}>{agent.name}</option>
        ))}
                </select>
              </div>
            </div>
          
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px !important'}}>
                <label className htmlFor="Industry">Merchant</label>
                <select onChange={handleChange}   value={filterData.merchantID} name="merchantID" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value="">Select Merchant</option>
                  {merchants.map(merchant => (
          <option key={merchant.value} value={merchant.value}>{merchant.name}</option>
        ))}
                </select>
              </div>
            </div>
            </>

)}
           
                <div className="col-md-12" style={{textAlign: 'right', marginTop: '10px', borderTop: '1px solid #dde0e5'}}>
              <button style={{backgroundColor: 'white', color: 'black', border: '1px solid black', padding: '3px 10px', fontSize:'13px'}} onClick={cancelFilter} type="button" name="btn_login_details" className="btn sebtn" id="cancel_filter">Cancel</button>
              <button style={{padding: '3px 10px', marginLeft:'5px'}} type="submit" name="btn_login_details" id="date_filter" className="btn ddfg sebtn" onClick={applyFilter}>Apply</button>
            </div>
          </div>
        </div>
      </div>
      </div>
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Roles));